// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-items-container{
    display: flex;
    flex-direction: row;
    width:100%;
    margin:20px 10%;
    margin-left: 5%;
    padding:20px;
    background-color: #fff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}

.blog-items-container img{
    
    width:300px;
    border-radius: 5px;
}
.blog-items-container img:hover{
    transform: scale(1.1);
}

.blog-items {
    padding-left: 50px;
    display: flex;
    flex-direction: column;
}

.blog-items h3{
    text-align: left;
    font-family: 'Raleway',sans-serif;
    letter-spacing: 1px;
    color:#E42727;
}

.blog-items p{
    text-align: left;
    font-family: 'Poppins',sans-serif;
    letter-spacing: 1px;
    font-size: 13px;
    /* color:#444; */
}

.blog-items button{
    width:120px;
    height:40px;
    background-color: #E42727;
    cursor: pointer;
    position: relative;
        overflow: hidden;
        z-index: 0;
        color:#fff;
   
}

.blog-items button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #ffa406;
    z-index: -1;

    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.blog-items button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}

.highlight {
    background-color: yellow;
    /* Highlight color */
    font-weight: bold;
    /* Emphasize the matched term */
    color: inherit;
        /* Ensure it inherits the text color */
        display: inline;
        /* Ensure it behaves like inline text */
        word-break: break-word;
        text-align: justify;
        font-size: Inherit;
        top:0;
}

@media screen and (max-width:768px){
    .blog-items-container {
            display: flex;
            flex-direction: column;
            width: 80%;
            margin: 20px 10%;
            margin-left: 5%;
            padding: 20px;
            background-color: #fff;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
        }
        .blog-items {
            padding-left: 10px;
            display: flex;
            flex-direction: column;
        }

        .blog-items-container img {
    
            width: 100%;
            border-radius: 5px;
        }
}`, "",{"version":3,"sources":["webpack://./src/Styles/blog-items.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;QACd,gBAAgB;QAChB,UAAU;QACV,UAAU;;AAElB;;AAEA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;;IAEX,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;;;AAIA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;QACV,sCAAsC;QACtC,eAAe;QACf,uCAAuC;QACvC,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,KAAK;AACb;;AAEA;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,UAAU;YACV,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,sBAAsB;YACtB,2CAA2C;QAC/C;QACA;YACI,kBAAkB;YAClB,aAAa;YACb,sBAAsB;QAC1B;;QAEA;;YAEI,WAAW;YACX,kBAAkB;QACtB;AACR","sourcesContent":[".blog-items-container{\n    display: flex;\n    flex-direction: row;\n    width:100%;\n    margin:20px 10%;\n    margin-left: 5%;\n    padding:20px;\n    background-color: #fff;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n}\n\n.blog-items-container img{\n    \n    width:300px;\n    border-radius: 5px;\n}\n.blog-items-container img:hover{\n    transform: scale(1.1);\n}\n\n.blog-items {\n    padding-left: 50px;\n    display: flex;\n    flex-direction: column;\n}\n\n.blog-items h3{\n    text-align: left;\n    font-family: 'Raleway',sans-serif;\n    letter-spacing: 1px;\n    color:#E42727;\n}\n\n.blog-items p{\n    text-align: left;\n    font-family: 'Poppins',sans-serif;\n    letter-spacing: 1px;\n    font-size: 13px;\n    /* color:#444; */\n}\n\n.blog-items button{\n    width:120px;\n    height:40px;\n    background-color: #E42727;\n    cursor: pointer;\n    position: relative;\n        overflow: hidden;\n        z-index: 0;\n        color:#fff;\n   \n}\n\n.blog-items button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #ffa406;\n    z-index: -1;\n\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.blog-items button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n.highlight {\n    background-color: yellow;\n    /* Highlight color */\n    font-weight: bold;\n    /* Emphasize the matched term */\n    color: inherit;\n        /* Ensure it inherits the text color */\n        display: inline;\n        /* Ensure it behaves like inline text */\n        word-break: break-word;\n        text-align: justify;\n        font-size: Inherit;\n        top:0;\n}\n\n@media screen and (max-width:768px){\n    .blog-items-container {\n            display: flex;\n            flex-direction: column;\n            width: 80%;\n            margin: 20px 10%;\n            margin-left: 5%;\n            padding: 20px;\n            background-color: #fff;\n            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n        }\n        .blog-items {\n            padding-left: 10px;\n            display: flex;\n            flex-direction: column;\n        }\n\n        .blog-items-container img {\n    \n            width: 100%;\n            border-radius: 5px;\n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
